import { all, fork } from 'redux-saga/effects';


/**
 * Toggle the class on body
 * @param {*} cssClass
 */

/**
 * ---------------------------------------------------------------------------------------------------------------------------
 * Note: Following are the functions which allows you to save the user prefrences on backend side by making an api request.
 * For now, we are just applying the required logic on frontend side
 * ----------------------------------------------------------------------------------------------------------------------------
 */


function* ChartDesignerConditionallitySaga(): any {
    yield all([]);
}

export default ChartDesignerConditionallitySaga;
